var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advisory-icon-header"},[_c('img',{staticClass:"icon",attrs:{"src":"/images/advisory/advisory-icon.svg"}})])
}]

export { render, staticRenderFns }